/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
// itg js
var currencySymbol = document.querySelector("[data-base-currency-symbol]").getAttribute("data-base-currency-symbol");
// itg js end

(function() {
  if(document.querySelectorAll('.delivery-info')) {
    // show modal on click
    var deliveryInfoClick = document.querySelectorAll('.delivery-info');
    deliveryInfoClick.forEach(function(selectedClickable){
      selectedClickable.onclick = function(){
        document.querySelector('.modal-bg').setAttribute('aria-hidden', 'false');
      }
    })
  }

  if(document.querySelectorAll('.close-modal').length) {
    // hide modal on click
    var modalCloseClick = document.querySelector('.close-modal-delivery');
    modalCloseClick.onclick = function(){
      document.querySelector('#modal-delivery').setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('no-scroll');
    }
    var modal = document.querySelectorAll(".modal-bg");
    window.onclick = function(event) {
      // console.log('hit', modal);
      for (let index = 0; index < modal.length; index++) {
        const element = modal[index];
        if (event.target == element) {
          // element.style.display = "none";
          element.setAttribute('aria-hidden', 'true');
          document.documentElement.classList.remove('no-scroll');
        }
      }
    }
  }


    // Update a given price label
    function setOptionLabel(option, option1, option2, option3, selectedValue, selectedValueBase, optionCurrencyFormat, baseCurrency) {
      let variantSelector = `${option1 ? `[data-option1="${option1}"]` : ``}${option2 ? `[data-option2="${option2}"]` : ``}${option3 ? `[data-option3="${option3}"]` : ``}`; // Find the matching variant
      let newOption = document.querySelector(variantSelector); // Select the matching variant
      // itg js
      if(newOption.textContent.replace(/[^0-9.-]+/g,"").charAt(0) == '.'){
        var newPriceVal = newOption.textContent.replace(/[^0-9.-]+/g,"").slice(1)
      }else{
        var newPriceVal = newOption.textContent.replace(/[^0-9.-]+/g,"");
      }
      let newOptionValue = +newPriceVal; // Get and convert the price of this variant
      // itg js end
      let newOptionValueBase = selectedValueBase ? +newOption.getAttribute(`data-currency-${baseCurrency.toLowerCase()}`).replace(/[^0-9.-]+/g,"") : null; // Get and convert the price of this variant in our base currency for formatting
      let optionLabel = option.querySelector(":scope > label > .ks-form-price-change"); // Get the price label wrapper
      let optionLabelSymbol = optionLabel.querySelector(":scope > span[data-addon-symbol]"); // ...and label symbol
      let optionLabelValue = optionLabel.querySelector(":scope > span[data-addon-price]"); // ...and label price

      if(selectedValue === newOptionValue) { // If there is no value change
        optionLabel.setAttribute('data-hide-price', true); // Set the wrapper to be hidden
      } else {
        optionLabel.setAttribute('data-hide-price', false); // Unhide the wrapper
        let diffValue = newOptionValue - selectedValue; // Calculate the difference
        let diffValueBase = selectedValueBase ? newOptionValueBase - selectedValueBase : null; // Calculate the difference in our base currency.
        // Update the label text
        if(diffValue >= 0) {
          optionLabelSymbol.textContent = "+";
          optionLabelValue.textContent = `${currencySymbol}${diffValue.toFixed(2)}`;
          // Then set our current currency attribute as a reference for conversion, as well as our base currency.
          optionLabelValue.setAttribute(`data-currency-${optionCurrencyFormat[1].toLowerCase().trim()}`, `${optionCurrencyFormat[0]}${diffValue}${optionCurrencyFormat[1]}`);
          if(diffValueBase !== null) {
            optionLabelValue.setAttribute(`data-currency-${baseCurrency.toLowerCase()}`, `${currencySymbol}${diffValueBase} ${baseCurrency}`);
          }
        } else {
          optionLabelSymbol.textContent = "-";
          optionLabelValue.textContent = `${currencySymbol}${(diffValue * -1).toFixed(2)}`; // Make the number positive
          // Remove our currency attributes so it doesn't mess with conversion
          optionLabelValue.removeAttribute('data-currency-usd');
          optionLabelValue.removeAttribute('data-currency-aud');
          optionLabelValue.removeAttribute('data-currency-eur');
          optionLabelValue.removeAttribute('data-currency-cad');
          // Then set our current currency attribute as a reference for conversion, as well as our base currency.
          optionLabelValue.setAttribute(`data-currency-${optionCurrencyFormat[1].toLowerCase().trim()}`, `${optionCurrencyFormat[0]}${diffValue * -1}${optionCurrencyFormat[1]}`);
          if(diffValueBase !== null) {
            optionLabelValue.setAttribute(`data-currency-${baseCurrency.toLowerCase()}`, `${currencySymbol}${diffValueBase * -1} ${baseCurrency}`);
          }
        }
      }
    }

    // Loops through our options and updates the price labels for them.
    function updateOptions(option1, option2, option3) {
      let baseCurrency = document.querySelector(`[data-base-currency]`).getAttribute('data-base-curency');
      baseCurrency = baseCurrency ? baseCurrency : 'USD';
      let selectedVariant = document.querySelector(`${option1 ? `[data-option1="${option1}"]` : ``}${option2 ? `[data-option2="${option2}"]` : ``}${option3 ? `[data-option3="${option3}"]` : ``}`);
      // itg js
      if(selectedVariant.textContent.replace(/[^0-9.-]+/g,"").charAt(0) == '.'){
        var newVarPriceVal = selectedVariant.textContent.replace(/[^0-9.-]+/g,"").slice(1)
      }else{
        var newVarPriceVal = selectedVariant.textContent.replace(/[^0-9.-]+/g,"");
      }
      let selectedValue = +newVarPriceVal; // Get the price of our selected variant
      // itg js end
      let selectedValueBase = selectedVariant.getAttribute(`data-currency-${baseCurrency.toLowerCase()}`) ? +selectedVariant.getAttribute(`data-currency-${baseCurrency.toLowerCase()}`).replace(/[^0-9.-]+/g,"") : null; // Get the price of our selected variant in our base currency for formatting, if there's no data-currency-usd then it's our main price
      let optionCurrencyFormat = selectedVariant.textContent.match(/[^0-9.-]+/g).filter(x => x !== ','); // Get the format of our currency for later, should be an array of 1-2 items.
      // itg js
      if(optionCurrencyFormat.length<2){
        optionCurrencyFormat.push(' ');
      }
      // itg js end
      // If we have an option1 value
      if(option1) {
        let option1Options = document.querySelectorAll('[data-option-index="0"]'); // get all our option1 options
        for (let option1_option of option1Options) { // for each option
          let option1_value = option1_option.querySelector(":scope > input").getAttribute("value"); // get the option value
          setOptionLabel(option1_option, option1_value, option2, option3, selectedValue, selectedValueBase, optionCurrencyFormat, baseCurrency); // update the label
        }
      }

      if(option2) {
        if(option2.toLowerCase() === 'unframed') {
          //shipping esimates
          document.querySelector('.framed-message').classList.remove("show");
          document.querySelector('.unframed-message').classList.add("show");
          //frame estimate
          if(document.querySelector('.frame_section')) {
          document.querySelector('.oak_framed').classList.remove("show");
          document.querySelector('.white_framed').classList.remove("show");
          document.querySelector('.black_framed').classList.remove("show");
          document.querySelector('.unframed').classList.add("show");
          }

          
        } else if(option2.toLowerCase() === 'raw oak frame') {
          //shipping esimates
          document.querySelector('.framed-message').classList.add("show")
          document.querySelector('.unframed-message').classList.remove("show")
          //frame estimate
          if(document.querySelector('.frame_section')) {
          document.querySelector('.white_framed').classList.remove("show")
          document.querySelector('.black_framed').classList.remove("show")
          document.querySelector('.unframed').classList.remove("show")
          document.querySelector('.oak_framed').classList.add("show")
        }
        }
        else if(option2.toLowerCase() === 'white frame') {
          //shipping esimates
          document.querySelector('.framed-message').classList.add("show")
          document.querySelector('.unframed-message').classList.remove("show")
          //frame estimate
          if(document.querySelector('.frame_section')) {
          document.querySelector('.oak_framed').classList.remove("show")
          document.querySelector('.black_framed').classList.remove("show")
          document.querySelector('.unframed').classList.remove("show")
          document.querySelector('.white_framed').classList.add("show")
        }
        }
        else if(option2.toLowerCase() === 'black frame') {
          //shipping esimates
          document.querySelector('.framed-message').classList.add("show")
          document.querySelector('.unframed-message').classList.remove("show")
          //frame estimate
          if(document.querySelector('.frame_section')) {
          document.querySelector('.oak_framed').classList.remove("show")
          document.querySelector('.white_framed').classList.remove("show")
          document.querySelector('.unframed').classList.remove("show")
          document.querySelector('.black_framed').classList.add("show")
        }
        }





        let option2Options = document.querySelectorAll('[data-option-index="1"]');
        for (let option2_option of option2Options) { // for each option
          let option2_value = option2_option.querySelector(":scope > input").getAttribute("value"); // get the option value
          setOptionLabel(option2_option, option1, option2_value, option3, selectedValue, selectedValueBase, optionCurrencyFormat, baseCurrency); // update the label
        }
      }

      if(option3) {
        let option3Options = document.querySelectorAll('[data-option-index="2"]');
        for (let option3_option of option3Options) { // for each option
          let option3_value = option3_option.querySelector(":scope > input").getAttribute("value"); // get the option value
          setOptionLabel(option3_option, option1, option2, option3_value, selectedValue, selectedValueBase, optionCurrencyFormat, baseCurrency); // update the label
        }
      }
    }

    // Updates our product summary
    function updateSummary(variant) {
      let baseCurrency = document.querySelector(`[data-base-currency]`).getAttribute('data-base-curency');
      baseCurrency = baseCurrency ? baseCurrency : 'USD';
      let selectedVariant = document.querySelector(`${variant.option1 ? `[data-option1="${variant.option1}"]` : ``}${variant.option2 ? `[data-option2="${variant.option2}"]` : ``}${variant.option3 ? `[data-option3="${variant.option3}"]` : ``}`);
      // itg js
      if(selectedVariant.textContent.replace(/[^0-9.-]+/g,"").charAt(0) == '.'){
        var newVarPriceVal = selectedVariant.textContent.replace(/[^0-9.-]+/g,"").slice(1)
      }else{
        var newVarPriceVal = selectedVariant.textContent.replace(/[^0-9.-]+/g,"");
      }
      let selectedValue = +newVarPriceVal; // Get the price of our selected variant
      // itg js end
      // let selectedValue = +selectedVariant.textContent.replace(/[^0-9.-]+/g,""); // Get the price of our selected variant
      let selectedValueBase = selectedVariant.getAttribute(`data-currency-${baseCurrency.toLowerCase()}`) ? +selectedVariant.getAttribute(`data-currency-${baseCurrency.toLowerCase()}`).replace(/[^0-9.-]+/g,"") : null; // Get the price of our selected variant in our base currency for formatting, if there's no data-currency-usd then it's our main price
      let optionCurrencyFormat = selectedVariant.textContent.match(/[^0-9.-]+/g).filter(x => x !== ','); // Get the format of our currency for later, should be an array of 1-2 items.
      if(optionCurrencyFormat.length<2){
        optionCurrencyFormat.push(' ');
      }
      let variantSelector = `${variant.option1 ? `[data-option1="${variant.option1}"]` : ``}${variant.option2 ? `[data-option2="${variant.option2}"]` : ``}${variant.option3 ? `[data-option3="${variant.option3}"]` : ``}`; // Find the matching variant
      let newOption = document.querySelector(variantSelector); // Select the matching variant
      // itg js
      if(newOption.textContent.replace(/[^0-9.-]+/g,"").charAt(0) == '.'){
        var newPriceVal = newOption.textContent.replace(/[^0-9.-]+/g,"").slice(1)
      }else{
        var newPriceVal = newOption.textContent.replace(/[^0-9.-]+/g,"");
      }
      let newOptionValue = +newPriceVal; // Get and convert the price of this variant
      // itg js end
      // let newOptionValue = +newOption.textContent.replace(/[^0-9.-]+/g,""); // Get and convert the price of this variant
      let newOptionValueBase = selectedValueBase ? +newOption.getAttribute(`data-currency-${baseCurrency.toLowerCase()}`).replace(/[^0-9.-]+/g,"") : null; // Get and convert the price of this variant in our base currency for formatting

      let variantComparePrice = variant.compare_at_price / 100;
      
      document.querySelector('[data-summary-variant]').innerHTML = variant.title.replace('/', '<br/>')
      
      document.querySelector('[data-summary-price]').textContent = `${optionCurrencyFormat[0]} ${newOptionValue}${optionCurrencyFormat[1]}`;
      // Then set our current currency attribute as a reference for conversion, as well as our base currency.
      // console.log(optionCurrencyFormat);
      document.querySelector('[data-summary-price]').setAttribute(`data-currency-${optionCurrencyFormat[1].toLowerCase().trim()}`, `${optionCurrencyFormat[0]}${newOptionValue}${optionCurrencyFormat[1]}`);
      document.querySelector('[data-summary-price]').setAttribute(`data-currency-${baseCurrency.toLowerCase()}`, `${currencySymbol}${newOptionValueBase} ${baseCurrency}`);
      if(variant.compare_at_price != null) {
        document.querySelector('[data-summary-price-compare]').style.display = 'block';
        document.querySelector('[data-summary-price-compare]').textContent = `${optionCurrencyFormat[0]}${variantComparePrice}${optionCurrencyFormat[1]}`;
         document.querySelector('.selected_price').classList.add('sale-price-active');
      } else {
        document.querySelector('[data-summary-price-compare]').style.display = 'none';
        document.querySelector('.selected_price').classList.remove('sale-price-active');
      }
      
      if(variant && variant.featured_image && variant.featured_image.src) {
        document.querySelector('[data-summary] img').setAttribute('src', variant.featured_image.src);
      }

    }

    let baseVariant = document.querySelectorAll('[data-variants][selected="selected"]'); // Get our default selected variant
    if(baseVariant && baseVariant[0]) { // If we found one
      // Get the options
      let option1 = baseVariant[0].getAttribute("data-option1");
      let option2 = baseVariant[0].getAttribute("data-option2");
      let option3 = baseVariant[0].getAttribute("data-option3");
      updateOptions(option1, option2, option3);
    }

    document.addEventListener('variant:changed', function(event) {
      var variant = event.detail.variant; // Gives you access to the whole variant details
      updateOptions(variant.option1, variant.option2, variant.option3);
      // console.log(variant);
      updateSummary(variant);
    });

    let touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      let moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  })();
